import { mixPanelClickHandler } from
  '@tracking/components/handlers/mixPanelHandler';

export function mixPanelTracking() {
  const gtmElements = document.getElementsByClassName(
    'gtm-track-element',
  );

  [...gtmElements].forEach(gtmElement => {
    const mixPanelTrackingAllowed = gtmElement.getAttribute(
      'data-gtm-tracking-allowed',
    );
    if (mixPanelTrackingAllowed && mixPanelTrackingAllowed === 'true') {
      gtmElement.addEventListener('click', mixPanelClickHandler);
    }
  });
}
